"use strict";

var _xLicense = require("@mui/x-license");
_xLicense.LicenseInfo.setLicenseKey("9a02f9ad7a0eff208eeea0f5e9f73896Tz03OTUxOCxFPTE3MzI3Njg1MTIwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=");